export const UNIT_OF_MEASUREMENT_GROUP_EXPORT_ID = 'group-unit-measurement';

export const UNIT_OF_MEASUREMENT_GROUP_TITLE = 'Grupos de Unidades de Medida';

export const LOCALIZED_PROPERTIES = {
  code: 'Codigo',
  name: 'Nombre',
  statusId: 'Estado',
};
